import { defineComponent as n, openBlock as a, createBlock as r, unref as m, mergeProps as l, withCtx as c, createElementVNode as p } from "vue";
import { RevIcon as h } from "@ds/components/Icon";
const d = /* @__PURE__ */ n({
  name: "IconGift",
  __name: "IconGift",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (i, e) => (a(), r(m(h), l(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M6.841 6.23C6.354 4.31 7.861 2.5 9.811 2.5A3.1 3.1 0 0 1 12 3.4a3.12 3.12 0 0 1 2.19-.9c1.948 0 3.456 1.81 2.969 3.73A3 3 0 0 1 16.844 7H19.5a1.25 1.25 0 0 1 1.25 1.25v3a1.25 1.25 0 0 1-1.25 1.25h-.25v7.75A1.25 1.25 0 0 1 18 21.5H6a1.25 1.25 0 0 1-1.25-1.25V12.5H4.5a1.25 1.25 0 0 1-1.25-1.25v-3A1.25 1.25 0 0 1 4.5 7h2.656a3 3 0 0 1-.315-.77M12.75 20h5v-7.5h-5V20m-1.5-7.5V20h-5v-7.5h5m1.5-1.5h6.5V8.5h-6.5V11m-1.5-2.5V11h-6.5V8.5h6.5m4.455-2.639A1.53 1.53 0 0 1 14.215 7h-1.467l-.005-1.816a4 4 0 0 0-.009-.25A1.59 1.59 0 0 1 14.19 4c1.025 0 1.748.941 1.515 1.861m-4.462-.673L11.248 7H9.785a1.53 1.53 0 0 1-1.49-1.139C8.061 4.941 8.785 4 9.81 4a1.6 1.6 0 0 1 1.345.726c.049.076.088.213.088.462",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
